<template>
  <v-parallax src="http://d-mebius.com/fusigi_na_shooting/img/bg.jpg">
    <ToplogoImage />
    <v-container class="my-16">
      <v-sheet
        style="max-width: 1280px; letter-spacing: 0.1em; line-height: 2em;"
        class="mx-auto my-12 pa-5 bg-white rounded-xl"
        border="lg opacity-12"
      >
        <p>
          「ふしぎなシューティングゲーム祭り」はゲームの試遊イベントです。<br>

        今回はシューティングゲームを中⼼にしたタイトルが出展されます。
        </p>
      </v-sheet>

      <AppNews />
    </v-container>
  </v-parallax>
</template>

<script>
  import AppNews from "./AppNews.vue";
  import ToplogoImage from "./ToplogoImage.vue";

  export default {
    name: "App",
    components: {
      AppNews,
      ToplogoImage,
    },
  };
</script>

<style scoped>
  .bold {
    color: #ff1744;
    font-weight: bold;
  }
</style>
